/**
 * Microsoft Clarity — brain-event.com (w4av80v8de)
 * init + consentV2 (required with cookie consent). Production only.
 * public/index.html calls window.__brainEventClaritySetConsent on Accept/Refuz.
 */

const CLARITY_PROJECT_ID = 'w4av80v8de';

let clarityApi = null;

function applyConsentV2(granted) {
  if (!clarityApi) return;
  const v = granted ? 'granted' : 'denied';
  try {
    clarityApi.consentV2({ ad_Storage: v, analytics_Storage: v });
  } catch {
    // non-fatal
  }
}

function readStoredConsentGranted() {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('cookie_consent_granted') === 'true';
  } catch {
    return false;
  }
}

export function bootstrapMicrosoftClarity() {
  if (process.env.NODE_ENV !== 'production') return;
  import('@microsoft/clarity')
    .then(({ default: clarity }) => {
      clarityApi = clarity;
      clarity.init(CLARITY_PROJECT_ID);
      applyConsentV2(readStoredConsentGranted());
      if (typeof window !== 'undefined') {
        window.__brainEventClaritySetConsent = function brainEventClaritySetConsent(granted) {
          applyConsentV2(!!granted);
        };
      }
    })
    .catch(() => {});
}
